// extracted by mini-css-extract-plugin
export var avatarContainer = "_9x-0";
export var avatarTypingWave = "_9x-i";
export var gray = "_9x-f";
export var green = "_9x-c";
export var icon = "_9x-9";
export var image = "_9x-1";
export var lg = "_9x-6";
export var md = "_9x-5";
export var presenceDot = "_9x-b";
export var red = "_9x-d";
export var sm = "_9x-4";
export var status = "_9x-a";
export var typingDot = "_9x-h";
export var typingPill = "_9x-g";
export var xl = "_9x-7";
export var xs = "_9x-3";
export var xxl = "_9x-8";
export var xxs = "_9x-2";
export var yellow = "_9x-e";